import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "px-2 sm:px-0 sm:max-h-screen sm:overflow-y-auto w-full sm:w-1/5 bg-transparant fixed top-0 left-0 sm:right-4 sm:left-auto z-50 flex flex-grow" }
const _hoisted_2 = { class: "flex flex-col w-full" }
const _hoisted_3 = { class: "px-4 font-bold" }
const _hoisted_4 = { class: "px-4 pt-2 pb-4 text-sm" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "h-1 w-full bg-accent-purple" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("ul", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.notifications, (notification) => {
        return (_openBlock(), _createElementBlock("li", {
          key: notification.id,
          class: "h-fit bg-background-light pt-4 w-full my-2 break-all flex flex-col rounded-sm shadow-md"
        }, [
          _createElementVNode("h4", _hoisted_3, _toDisplayString(notification.subject), 1),
          _createElementVNode("p", _hoisted_4, _toDisplayString(notification.message), 1),
          _hoisted_5
        ]))
      }), 128))
    ])
  ]))
}